import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getQuestionnaireResponseByLinkId } from 'utils';
import CopyButton from '../../../../../components/CopyButton';
import { useAppointmentData } from '../../../shared/stores/appointment/appointment.store';
import { InformationCard } from './InformationCard';

export const ContactContainer: FC = () => {
  const { t } = useTranslation();
  const { questionnaireResponse } = useAppointmentData();

  const streetAddress = getQuestionnaireResponseByLinkId('patient-street-address', questionnaireResponse)?.answer?.[0]
    .valueString;

  const streetAddressLine2 = getQuestionnaireResponseByLinkId('patient-street-address-2', questionnaireResponse)
    ?.answer?.[0]?.valueString;

  const cityStateZipString = `
    ${getQuestionnaireResponseByLinkId('patient-city', questionnaireResponse)?.answer?.[0]
      .valueString}, ${getQuestionnaireResponseByLinkId('patient-state', questionnaireResponse)?.answer?.[0]
      .valueString}, ${getQuestionnaireResponseByLinkId('patient-zip', questionnaireResponse)?.answer?.[0]?.valueString}
  `;

  const fillingOutAs = getQuestionnaireResponseByLinkId('patient-filling-out-as', questionnaireResponse)?.answer?.[0]
    .valueString;

  const patientEmail = getQuestionnaireResponseByLinkId('patient-email', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  const patientMobile = getQuestionnaireResponseByLinkId('patient-number', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  const guardianEmail = getQuestionnaireResponseByLinkId('guardian-email', questionnaireResponse)?.answer?.[0]
    .valueString;

  const guardianMobile = getQuestionnaireResponseByLinkId('guardian-number', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  const sendMarketingMessages =
    getQuestionnaireResponseByLinkId('mobile-opt-in', questionnaireResponse)?.answer?.[0]?.valueString || t('No', 'No');

  return (
    <InformationCard
      title={t('contactInfo.title', 'Contact information')}
      fields={[
        {
          label: t('contactInfo.streetAddress', 'Street address'),
          value: streetAddress,
          button: <CopyButton text={streetAddress || ''} />,
        },
        {
          label: t('contactInfo.addressLine2', 'Address line 2'),
          value: streetAddressLine2,
          button: <CopyButton text={streetAddressLine2 || ''} />,
        },
        {
          label: t('contactInfo.cityStateZip', 'City, State, ZIP'),
          value: cityStateZipString,
        },
        {
          label: t('contactInfo.fillingOutAs', 'I am filling out this info as'),
          value: fillingOutAs,
        },
        {
          label: t('contactInfo.patientEmail', 'Patient email'),
          value: patientEmail,
          button: <CopyButton text={patientEmail || ''} />,
        },
        {
          label: t('contactInfo.patientMobile', 'Patient mobile'),
          value: patientMobile,
          button: <CopyButton text={patientMobile || ''} />,
        },
        {
          label: t('contactInfo.guardianEmail', 'Parent/Guardian email'),
          value: guardianEmail,
          button: <CopyButton text={guardianEmail || ''} />,
        },
        {
          label: t('contactInfo.guardianMobile', 'Parent/Guardian mobile'),
          value: guardianMobile,
          button: <CopyButton text={guardianMobile || ''} />,
        },
        {
          label: t('contactInfo.marketingMessages', 'Send marketing messages'),
          value: sendMarketingMessages,
        },
      ]}
    />
  );
};
